import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomTabs, CustomTab } from '../CustomTabs';
import AmbienteExternoTipo from './AmbienteExternoTipo';

const AmbienteExterno: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ margin: 'auto' }}>
      <CustomTabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        variant="fullWidth"
      >
        <CustomTab tabTitle="Político" content={<AmbienteExternoTipo tipo="politico" titulo="Político" descricao="Análise dos fatores políticos. Classifique o impacto, probabilidade e tendência para cada opção." />} />
        <CustomTab tabTitle="Econômico" content={<AmbienteExternoTipo tipo='economico' titulo="Análise Econômica" descricao="Análise dos fatores econômicos. Classifique o impacto, probabilidade e tendência para cada opção."/>} />
        <CustomTab tabTitle="Social" content={<AmbienteExternoTipo tipo='social' titulo="Análise Social" descricao="Análise dos fatores sociais. Classifique o impacto, probabilidade e tendência para cada opção." />} />
        <CustomTab tabTitle="Tecnológico" content={<AmbienteExternoTipo tipo='tecnologico' titulo="Análise Tecnológica" descricao="Análise dos fatores tecnológicos. Classifique o impacto, probabilidade e tendência para cada opção." />} />
        <CustomTab tabTitle="Ambiental" content={<AmbienteExternoTipo tipo='ambiental' titulo="Análise Ambiental" descricao="Análise dos fatores ambientais. Classifique o impacto, probabilidade e tendência para cada opção." />} />
        <CustomTab tabTitle="Legal" content={<AmbienteExternoTipo tipo='legal' titulo="Análise Legal" descricao="Análise dos fatores legais. Classifique o impacto, probabilidade e tendência para cada opção." />} />
      </CustomTabs>
    </Box>
  );
};

export default AmbienteExterno;